export { BackgroundColorKeys, TextColorKeys } from './types/stringKeys';
export { getBackgroundColorValue } from './utils/backgroundColors';
export { getTextColorValue } from './utils/textColors';
